<template>
  <div>
    <Breadcrumbs main="Admin" :title="$route.params.stage +' Submissions'" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header header-mobile">
              <router-link to="/admin/submission-create/0">
                <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                  <i class="fa fa-light fa-plus"></i>
                  <h7>Add New Proposal</h7>
                </button>
              </router-link>
            </div>

            <div class="card-body">
              <b-row>
                <b-col xl="6">
                  <div class="d-flex flex-column flex-xl-row " style="gap: 10px;">
                    <b-input-group class="datatable-btn">
                      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>

                  </div>

                </b-col>

                <b-col xl="6">
                  <b-form-group label-cols="2" label="Per page" class="mb-0 datatable-select">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <div v-if="!loading && !error">
                <div class="table-responsive datatable-vue">
                  <b-table show-empty stacked="md" :items="items" :fields="tablefields" :filter="filter" :per-page="perPage" @filtered="onFiltered">
                    <template #cell(index)="data">
                      {{ (currentPage - 1) * perPage + data.index + 1 }}
                    </template>

                    <template #cell(user.full_name)="row">
                      {{row.value}}
                      <br>

                      <small style="color:red">{{row.item.created.split('T')[0]}}</small>
                    </template>
                    <template #cell(team_name)="row">

                      <router-link :to="`/admin/submission-detail/${row.item.id}`" class="link-style" v-if="user_type=='Admin'">
                        {{ row.value }}
                      </router-link>
                      <router-link :to="`/admin/review/submission-detail/${row.item.id}`" class="link-style" v-else >
                        {{ row.value }}
                      </router-link>
                    </template>
                    <template #cell(updated_by.full_name)="row">
                      {{row.value}}<br>
                      <small style="color:red">{{row.item.updated.split('T')[0]}}</small>

                    </template>

                    <template #cell(status)="row">
                      <span v-if="row.value=='Rejected'"  style="cursor: pointer;" >
                                                    <b-badge variant="danger">{{ row.value }}</b-badge>
                                                </span>
                                                <span v-else-if="row.value=='Incomplete'"  style="cursor: pointer;" >
                                                    <b-badge variant="warning">{{ row.value }}</b-badge>
                                                </span>
                      <span v-else style="cursor: pointer;" >
                                                    <b-badge variant="success">{{ row.value}}</b-badge>
                                                </span>

                    </template>
                    <template #cell(assigned_groups)="row">
                      <div v-if="row.item.assigned_groups !== null && row.item.assigned_groups.length > 0">
                        <div v-for="group in row.item.assigned_groups" :key="group.id">
                          <b-badge variant="success"  @click="deleteGroupFromSubmission(group.group.id, row.item.id)" >
                            <h7>{{ group.group.name}}</h7>
                            <b-icon icon="x"></b-icon>
                          </b-badge>


                        </div>
                      </div>
                      <div v-b-modal.modal-prevent-closing-label @click="addGroupToSubmission(row.item)" v-if="row.item.submission_screening">
                        <b-badge pill variant="secondary">Add Group</b-badge>
                      </div>
                      <div class="table-responsive datatable-vue font-secondary" v-else>
                        <b-button @click="$router.push(`/admin/submission-detail/${row.item.id}`)">Not Screened Yet</b-button>
                      </div>
                    </template>
                    <template #cell(my_remarks)="row">
                      <div v-if="row.value">

                          <b-badge variant="success"   >
                            <h7 >Done</h7>
                          </b-badge>
                      </div>

                        <div class="table-responsive datatable-vue font-secondary" v-else>
                          <b-button @click="$router.push(`/admin/review/submission-detail/${row.item.id}`)">Not Reviewed Yet</b-button>
                        </div>


                    </template>



                  </b-table>
                </div>
              </div>

              <b-col md="6" class="my-1 p-0">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
              </b-col>

            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
      <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this Fellowship?</div>
    </b-modal>
    <b-modal id="modal-prevent-closing-label" ref="modal" title="Add Group" @show="resetLabelModal"  @ok="handleOk">

      <div class="form-group">
        <label class="col-form-label">Group</label>
        <div style="position: relative; width: 100%;">
          <select class="form-control" v-model="submit_data.group">
            <option v-for="option in groups" :key="option.id" :value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
      </div>

    </b-modal>


  </div>
</template>

<script>
  import {
    mapState
  } from 'vuex';
  import Swal from 'sweetalert2/dist/sweetalert2.js';
  import 'sweetalert2/src/sweetalert2.scss';

  import {
    host
  } from '../../_helpers/APIPath';
  export default {

    data() {
      return {
        host: host,
        submit_data:{
          submission:null,
          group:null,

        },
        tablefields: [{
                        key: 'index',
                        label: '#'
                      },

                      {
                        key: 'team_name',
                        label: 'Team Name',
                        sortable: true
                      },
                      {
                        key: 'user.full_name',
                        label: 'User',
                        sortable: true
                      },

                      {
                        key: 'status',
                        label: 'Status',
                        sortable: true
                      },
                      {
                        key: 'updated_by.full_name',
                        label: 'Updated By',
                        sortable: true
                      },

        ],

        filter: null,
        delete_value: null,

        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [5, 10, 15],
        user_type:""
      };
    },

    computed: {
    ...mapState({
      items: state => state.submission.submission,
      groups: state => state.manage_user.group,
      loading: state => state.submission.submissionLoading,
      error: state => state.submission.submissionError,
    }),

    sortOptions() {
      return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return {
              text: f.label,
              value: f.key
            };
          });
    }
    },

    watch: {
      '$route.params.stage': {
        immediate: true,
        handler() {
          if(this.$route.params.stage!=='All'){
            this.$store.dispatch('submission/fetchSubmissionListByStage',this.$route.params.stage).then(() => {
              this.totalRows = this.items;


            });
          } else{
            this.$store.dispatch('submission/fetchSubmissionList').then(() => {
              this.totalRows = this.items;

            });
          }
        }
      }
    },
    mounted() {
      console.log('Component mounted.');
    },
    beforeUpdate(){
      console.log('Component Routed.');
    },

    created() {
      this.user_type=JSON.parse(localStorage.getItem('user'))?.user_object.profile_info.type;
      this.totalRows = [];
      if(this.$route.params.stage!=='All'){
        this.$store.dispatch('submission/fetchSubmissionListByStage',this.$route.params.stage).then(() => {
          this.totalRows = this.items;

        });
        if(this.user_type=='Reviewer'){
          this.tablefields.push({
            key: 'my_remarks',
            label: 'Review Status',
            sortable: false
          })
        }else{
          this.tablefields.push({
            key: 'avg_mark',
            label: 'Marks',
            sortable: true
          })
        }
      } else{
        this.$store.dispatch('submission/fetchSubmissionList').then(() => {

          this.totalRows = this.items;

        });

      }
      this.$store.dispatch('manage_user/fetchGroupList').then(() => {
      });

      if(this.user_type=='Admin'){
        this.tablefields.push({
          key: 'assigned_groups',
          label: 'Assigned Groups',
          sortable: false
        })
      }

    },

    methods: {

      truncateText(text, maxLength) {
        if (text.length > maxLength) {
          return text.substring(0, maxLength) + '...';
        } else {
          return text;
        }
      },

      resetModal() {
        this.selectedStatus = '';
      },

      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      addGroupToSubmission(item){
        this.submit_data.submission=item.id;
      },
      deleteGroupFromSubmission(group_id, submission_id) {
        let payload={
          group: group_id,
          submission: submission_id,
        };
        console.log(payload);
        this.$store.dispatch('manage_user/removeSubmissionFromGroup', payload).then(response => {
          if (response.code == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });
            this.$store.dispatch('submission/fetchSubmissionList').then(() => {
              this.totalRows = this.items;

            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });
      },
      handleOk() {

        console.log(this.submit_data);
        this.$store.dispatch('manage_user/addSubmissionToGroup', this.submit_data).then(response => {
          if (response.code == 201) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });
            this.$store.dispatch('submission/fetchSubmissionList').then(() => {
              this.totalRows = this.items;

            });
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });
      },

      updatefellowshipStatus(id){
        this.$store.dispatch('fellowship/updateStatusToggle', {
          fellowship_id: id,
        }).then(response => {
          if (response.status == 200) {
            Swal.fire({
              title: 'Success!',
              text: response.response,
              icon: 'success'
            });

            this.delete_value = null;

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.response,
              icon: 'error'
            });
          }
        });
      }

    }
  };
</script>

<style scoped>
.header-mobile {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 460px) {
  .header-mobile {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: start;
  }
}
</style>
